import API from "@/api/modules/specialities";

const state = () => ({
  specialities: [],
  accreditations: [],
});

export default {
  namespaced: true,
  state,
  mutations: {
    SET_DATA(state, { type, data }) {
      state[type] = data;
    },
  },
  actions: {
    getSpecialities({ commit }) {
      return API.getSpecialities().then((response) => {
        if (response && response.data) {
          commit("SET_DATA", { type: "specialities", data: response.data.specialities || [] });
        }
      });
    },
    upsertSpeciality(_, data) {
      return API.upsertSpeciality(data);
    },
    getAccreditations({ commit }) {
      return API.getAccreditations().then((response) => {
        if (response && response.data) {
          commit("SET_DATA", { type: "accreditations", data: response.data.accreditations || [] });
        }
      });
    },
    upsertAccreditation(_, payload) {
      return API.upsertAccreditation(payload);
    },
  },
};
